// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"60e5c4e5","3296":"b9365b3f"}[chunkId] + ".chunk.css";
};